export const LIST_TRANSFER_WITH_AMOUNT = 'LIST_TRANSFER_WITH_AMOUNT';
export const FETCH_TRANSFER_WITH_AMOUNT = 'FETCH_TRANSFER_WITH_AMOUNT';
export const LIST_TRANSFER_WITH_PERCENTAGE = 'LIST_TRANSFER_WITH_PERCENTAGE';
export const FETCH_TRANSFER_WITH_PERCENTAGE = 'FETCH_TRANSFER_WITH_PERCENTAGE';
export const LIST_TRANSFER_WITH_PERCENTAGE_SC = 'LIST_TRANSFER_WITH_PERCENTAGE_SC';
export const FETCH_TRANSFER_SHARE_CONFIG = 'FETCH_TRANSFER_SHARE_CONFIG';
export const LIST_TRANSFER_SHARE_CONFIG = 'LIST_TRANSFER_SHARE_CONFIG';
export const CLEAR_TRANSFER_SHARE_CONFIG = 'CLEAR_TRANSFER_SHARE_CONFIG';
export const FETCH_TRANSFER_SHARE_CONFIG_BY_LOTTERY = 'FETCH_TRANSFER_SHARE_CONFIG_BY_LOTTERY';
export const LIST_TRANSFER_SHARE_CONFIG_BY_LOTTERY = 'LIST_TRANSFER_SHARE_CONFIG_BY_LOTTERY';
export const CLEAR_TRANSFER_SHARE_CONFIG_BY_LOTTERY = 'CLEAR_TRANSFER_SHARE_CONFIG_BY_LOTTERY';
